<template>
  <div class="service-card">
    <h1 class="service-title">{{title}}</h1>
    <!-- <div class="service-info">
      <p class="service-description" v-html="description"></p>
      <router-link to="/contacts">
        <p>Vamos bater um papo?</p>
      </router-link>
    </div>-->
    <div class="service-img">
      <img :src="`${imgUrl}`" :alt="imgAlt" />
    </div>
    <div class="know-more">
      <router-link :to="`/services/${slug}`">+ informações</router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "description", "imgUrl", "imgAlt", "slug"],
  data() {
    return {};
  }
};
</script>

<style scoped lang="scss">
.service-card {
  background-color: #fff;
  height: 500px;
  // margin: 5px;
  margin-bottom: 20px;
  width: 100%;
  border-radius: 15px;
  border: 1px;
  border-style: solid;
  border-color: rgba(0, 156, 74, 0.4);

  // box-shadow: 3px 4px 1px #009c49;
  // box-shadow: 3px 4px 1px rgba(0, 156, 74, 0.4);
  // box-shadow: 3px 4px 1px rgba(0, 0, 0, 0.5);
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  // margin: 0 20px 20px 0;
  transition: all 0.2s ease;

  @include for-tablet-portraid-up {
    width: 48%;
    // margin: 0 5px 10px 5px;
  }
  @include for-tablet-landscape-up {
    width: 24%;
    // margin: 0 5px 20px 5px;
    &:hover {
      box-shadow: 2px 2px 5px rgba(0, 156, 74, 0.4);
      transform: scale(1.05);
    }
  }
  h1 {
    font-size: 1.5rem;
    // color: $verde-exception;
    text-align: center;
    margin: 20px 0 0 0;
    // margin-top: 30px
    // @include for-tablet-portraid-up {
    //   font-size: 2rem;
    // }
  }

  .service-img {
    margin: 10px 0;
    img {
      width: 100%;
    }
  }
  .know-more {
    // width: 100%;
    margin: 10px 0;
    display: flex;
    a {
      font-size: 1rem;
      width: 100%;
      text-decoration: none;
      font-weight: 600;
      color: #fff;
      border-radius: 8px;
      background: $verde-exception;
      padding: 10px 30px;
      text-align: center;
      transition: all 0.2s ease;
      &:hover {
        // transform: scale(1.05);
        opacity: 0.9;
      }
    }
  }
}
</style>